<template>
  <div class="home" v-show="page_finish">
    <v-app-bar>
      <v-spacer></v-spacer>
      <v-img
        alt="Vuetify Logo"
        class="shrink mr-2"
        contain
        src="https://shop.cheerlife.io/img/logo_a.png"
        transition="scale-transition"
        width="22"
      />
      <v-toolbar-title>{{ $t("Home_title1") }}</v-toolbar-title>
      <v-spacer></v-spacer>
    </v-app-bar>
    <v-card class="mx-auto">
      <v-img height="250" :src="shop_info.image_url"></v-img>
      <div class="share__area__sty">
        <v-btn text @click="shareLink">
          <v-icon left dark>
            mdi-share-variant
          </v-icon>
          {{ $t("Home_button4") }}
        </v-btn>
        <input
          readonly
          type="hidden"
          class="form-control copyLinkInput"
          :value="shareURL"
        />
      </div>
      <div class="d-flex flex-no-wrap justify-space-between">
        <v-card-title>{{ shop_info.name }}</v-card-title>
        <v-card-title
          >{{ $t("Home_title2_1") }}${{ shop_info.comma_shipping_free
          }}{{ $t("Home_title2_2") }}</v-card-title
        >
      </div>
      <v-card-text>
        <v-row align="center" class="mx-0" style="margin-top: -25px;">
          <div>{{ shop_info.spec }}</div>
        </v-row>
        <div class="d-flex flex-no-wrap justify-space-between">
          <div class="my-4 headline red--text">
            NT${{ shop_info.special_price }}{{ $t("Home_text1") }}
          </div>
          <div
            class="my-4 subtitle-1 black--text"
            style="text-decoration: line-through;"
          >
            NT${{ shop_info.price }}
          </div>
        </div>
      </v-card-text>
    </v-card>
    <v-card class="mx-auto mt-3 mb-5">
      <v-card-title>{{ $t("Home_title3") }}</v-card-title>
      <v-card-text>
        <div class="shopinfo_sty" v-html="shop_info.content"></div>
      </v-card-text>
    </v-card>
    <br /><br />
    <!-- share copy info -->
    <v-snackbar
      v-model="show_area[0].showcopysnackbar"
      :multi-line="copymultiLine"
      :timeout="copysnackbartime"
      centered
    >
      <span v-html="copy_state"></span>
      <v-btn color="blue" text @click="show_area[0].showcopysnackbar = false">
        {{ $t("close_button") }}
      </v-btn>
    </v-snackbar>
    <!-- login -->
    <v-dialog v-model="login_dialog" width="500" persistent v-if="not_login">
      <template v-slot:activator="{ on }">
        <v-bottom-navigation color="white" grow fixed>
          <v-btn block color="error" v-on="on" class="bottom_btn">
            <span class="white--text">{{ $t("Home_button1") }}</span>
            <v-icon class="white--text">mdi-home-import-outline</v-icon>
          </v-btn>
        </v-bottom-navigation>
      </template>
      <v-stepper v-model="login_info[0].el">
        <v-stepper-items>
          <v-stepper-content step="1">
            <div class="mb-3">
              <v-card-title class="headline">{{
                $t("Home_title4")
              }}</v-card-title>
              <v-card-text>
                <v-text-field
                  v-model="login_info[0].mobile"
                  type="number"
                  :label="$t('mobile_input')"
                ></v-text-field>
              </v-card-text>
            </div>
            <v-btn color="primary" @click="checkUserState()">
              {{ $t("next_button") }}
            </v-btn>
            <v-btn text @click="dialogCancel()">{{
              $t("cancel_button")
            }}</v-btn>
          </v-stepper-content>
          <v-stepper-content step="2">
            <div class="mb-3">
              <v-card-title class="headline">{{
                $t("Home_title5")
              }}</v-card-title>
              <v-card-text>
                <v-text-field
                  v-model="login_info[0].mobile"
                  type="number"
                  :label="$t('mobile_input')"
                ></v-text-field>
                <div class="text-center mb-5">
                  <v-btn
                    color="error"
                    @click="SendSMSCode()"
                    :disabled="sms_btn[0].smsbtndisable"
                  >
                    {{ $t("Home_button2") }}
                    <span class="pl-2" v-show="sms_btn[0].smsbtndisable">
                      {{ sms_btn[0].smsCountDown }}{{ $t("Home_text2") }}
                    </span>
                  </v-btn>
                </div>
                <v-text-field
                  v-model="login_info[0].sns"
                  :label="$t('Home_input1')"
                  outlined
                ></v-text-field>
              </v-card-text>
            </div>
            <v-btn color="primary" @click="CheckSMSCode()">
              {{ $t("doubleCheck_button") }}
            </v-btn>
            <v-btn text @click="dialogCancel()">{{
              $t("cancel_button")
            }}</v-btn>
          </v-stepper-content>
          <v-stepper-content step="3">
            <div class="mb-3">
              <v-card-title class="headline">{{
                set_password_tittle
              }}</v-card-title>
              <v-card-subtitle>{{ $t("Home_text3") }}</v-card-subtitle>
              <v-card-text>
                <v-text-field
                  :append-icon="
                    show_area[0].password1 ? 'mdi-eye' : 'mdi-eye-off'
                  "
                  :type="show_area[0].password1 ? 'text' : 'password'"
                  @click:append="
                    show_area[0].password1 = !show_area[0].password1
                  "
                  v-model="login_info[0].newpassword"
                  :label="$t('password_input')"
                ></v-text-field>
                <v-text-field
                  :append-icon="
                    show_area[0].password2 ? 'mdi-eye' : 'mdi-eye-off'
                  "
                  :type="show_area[0].password2 ? 'text' : 'password'"
                  @click:append="
                    show_area[0].password2 = !show_area[0].password2
                  "
                  v-model="login_info[0].checknewpassword"
                  :label="$t('doubleCheckPassword_input')"
                ></v-text-field>
              </v-card-text>
            </div>
            <v-btn color="primary" @click="SendPassword()">
              {{ $t("sendPassword_button") }}
            </v-btn>
            <v-btn text @click="dialogCancel()">{{
              $t("cancel_button")
            }}</v-btn>
          </v-stepper-content>
          <v-stepper-content step="4">
            <div>
              <v-card-title class="headline">{{
                $t("Home_title7")
              }}</v-card-title>
              <v-card-text class="mb-n5">
                <v-text-field
                  v-model="login_info[0].mobile"
                  :label="$t('mobile_input')"
                ></v-text-field>
                <v-text-field
                  :append-icon="
                    show_area[0].password3 ? 'mdi-eye' : 'mdi-eye-off'
                  "
                  :type="show_area[0].password3 ? 'text' : 'password'"
                  @click:append="
                    show_area[0].password3 = !show_area[0].password3
                  "
                  v-model="login_info[0].password"
                  :label="$t('password_input')"
                ></v-text-field>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn text @click="forgetPassword()">{{
                  $t("forgetPassword_button")
                }}</v-btn>
              </v-card-actions>
            </div>
            <v-btn color="primary" @click="SendLogin()">
              {{ $t("send_button") }}
            </v-btn>
            <v-btn text @click="dialogCancel()">{{
              $t("cancel_button")
            }}</v-btn>
          </v-stepper-content>
        </v-stepper-items>
      </v-stepper>
    </v-dialog>
    <v-bottom-sheet v-model="spec_sheet" scrollable v-else>
      <template v-slot:activator="{ on }">
        <v-bottom-navigation color="white" grow fixed>
          <v-btn
            block
            color="blue-grey lighten-1 white--text"
            v-on="on"
            class="bottom_btn"
          >
            <span class="white--text">{{ $t("Home_button3") }}</span>
            <v-icon class="white--text">mdi-cart-outline</v-icon>
          </v-btn>
        </v-bottom-navigation>
      </template>
      <v-card>
        <v-card-text class="ma-0 pa-0">
          <div>
            <v-list-item>
              <v-row>
                <v-col cols="4">
                  <v-img
                    :src="shop_info.image_url"
                    :alt="shop_info.name"
                    width="100"
                  ></v-img>
                </v-col>
                <v-col cols="6">
                  <p
                    class="deep-orange--text text--darken-1 font-weight-medium headline"
                  >
                    NT$ <font>{{ select_info[0].spec_price }}</font>
                    <font class="d-none">{{ select_info[0].spec_id }}</font>
                  </p>
                  <p class="mb-2">{{ shop_info.name }}</p>
                  <p class="mb-1">{{ shop_info.spec }}</p>
                  <p>
                    {{ $t("Home_title2_1") }}
                    {{ shop_info.comma_shipping_free }}
                    {{ $t("Home_title2_2") }}
                  </p>
                </v-col>
                <v-col cols="2">
                  <v-btn
                    icon
                    color="error"
                    @click="selectSpecs()"
                    class="float-right"
                  >
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                </v-col>
              </v-row>
            </v-list-item>
          </div>
          <v-divider></v-divider>
          <div>
            <v-card-title class="subtitle-1 font-weight-medium pb-1">
              {{ $t("Home_text5") }}
            </v-card-title>
            <v-chip-group
              class="px-3 pb-3"
              v-model="select_info[0].spec_selection"
              active-class="deep-orange--text text--darken-1"
              mandatory
            >
              <v-chip
                v-for="(item, idx) in shop_info.spec_list"
                :key="'A' + idx"
                @change="changeSpec(idx)"
              >
                {{ item.spec_name }}{{ $t("Home_text4") }}
              </v-chip>
            </v-chip-group>
          </div>
          <v-divider></v-divider>
          <div>
            <v-card-title class="subtitle-1 font-weight-medium">{{
              $t("Home_text6")
            }}</v-card-title>
            <div v-show="is_vending_machine">
              <p class="display-1 font-weight-regular mx-5">
                {{ select_info[0].num_selection }}
              </p>
            </div>
            <div v-show="!is_vending_machine">
              <v-btn class="mx-5 mb-5" small @click="minusClick">
                <v-icon>mdi-minus</v-icon>
              </v-btn>
              <span class="display-1 font-weight-regular">{{
                select_info[0].num_selection
              }}</span>
              <v-btn class="mx-5 mb-5" small @click="plusClick">
                <v-icon>mdi-plus</v-icon>
              </v-btn>
            </div>
          </div>
          <v-divider></v-divider>
          <div>
            <v-card-title class="pl-4 subtitle-1 font-weight-medium">
              {{ $t("Home_text7") }}：
              <font class="headline deep-orange--text text--darken-1">
                NT$
                {{ select_info[0].num_selection * select_info[0].spec_price }}
              </font>
            </v-card-title>
          </div>
          <v-divider></v-divider>
          <div v-if="!is_vending_machine">
            <v-list-item>
              <v-list-item-content>
                <v-list-item-title class="subtitle-1 font-weight-medium">{{
                  $t("Home_text8")
                }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-textarea
              outlined
              name="memo"
              label=""
              v-model="select_info[0].memo"
              class="mx-4"
            ></v-textarea>
          </div>
          <div v-else>
            <v-list-item>
              <v-list-item-content>
                <v-list-item-title class="subtitle-1 font-weight-medium"
                  >想對TA說</v-list-item-title
                >
              </v-list-item-content>
            </v-list-item>
            <v-textarea
              outlined
              name="memo"
              label="請輸入你想說的話，限30字內"
              v-model="select_info[0].memo"
              maxlength="30"
              class="mx-4"
            ></v-textarea>
          </div>
          <div class="mb-5" align="center" justify="center">
            <button
              :id="group_uuid"
              class="goshopbuy v-btn v-btn--contained theme--dark v-size--default warning"
              color="warning"
              dark
              :data-useruuid="login_info[0].user_uuid"
              @click="BuyShop()"
            >
              {{ $t("ok_button1") }}
            </button>
          </div>
        </v-card-text>
      </v-card>
    </v-bottom-sheet>
    <CheerLifeFooter />
  </div>
</template>

<script>
// @ is an alias to /src
import Vue from "vue";
import CheerLifeFooter from "@/components/CheerLifeFooter.vue";

export default {
  name: "home",
  components: { CheerLifeFooter },
  computed: {},
  data: () => ({
    page_finish: false,
    access_key: "rIhTQzuOwZ54asxqRMNkYVF3n6UA7v9c",
    group_uuid: "",
    production_id: "",
    shop_info: [],
    // app mobile
    mobile: "",
    // web login
    login_info: [
      {
        el: 1,
        mobile: "",
        state: "",
        sns: "",
        resetsns: "",
        newpassword: "",
        checknewpassword: "",
        token: "",
        user_uuid: "",
        password: "",
      },
    ],
    login_dialog: false,
    not_login: true,
    spec_sheet: false,
    select_info: [
      {
        // 所選組數單價
        spec_price: 0,
        // 所選組數 id
        spec_id: "",
        // 所選組數名稱
        spec_name: 1,
        // 所選組數種類
        spec_selection: 0,
        // 數量
        num_selection: 1,
        memo: "",
        // 免運門檻
        shipping_free: 0,
        comma_shipping_free: 0,
        // 運費
        shipping_fee: 0,
        // 種類*數量
        cal_price: 0,
        // 總價
        total_price: 0,
      },
    ],
    show_area: [
      {
        password1: false,
        password2: false,
        password3: false,
        showcopysnackbar: false,
      },
    ],
    // 簡訊按鈕倒數
    sms_btn: [
      {
        smsCountDown: 180,
        smsbtndisable: false,
      },
    ],
    // 設定密碼文字
    set_password_tittle: "請設定密碼,作為下次登入使用",
    // 智販機隱藏加減按鈕
    is_vending_machine: true,
    // 分享連結
    shareURL: "",
    copy_state: "",
    copymultiLine: true,
    copysnackbartime: 5000,
  }),
  methods: {
    // 分享
    initShareURL() {
      let url = window.location.href;
      const splitURL = url.split("&phone=");
      this.shareURL = `CheerLife 生活趣兒 / 有個商品推薦給您，趕快點連結購買！Recommend you this product, click the purchase link!\n${splitURL[0]}`;
    },
    shareLink() {
      const selectEl = document.getElementsByClassName("copyLinkInput")[0];
      if (selectEl.value === "") {
        this.copy_state = "複製失敗：無網址";
        this.show_area[0].showcopysnackbar = true;
        return false;
      } else {
        selectEl.setAttribute("type", "text");
        selectEl.select();
        try {
          const copysuccessful = document.execCommand("copy");
          this.copy_state = copysuccessful
            ? "已複製網址，現在您可轉貼此網址。<br />URL copied, Share with others."
            : `請複製並轉貼此網址。<br />URL copied, Share with others.'<input class="d-block showcopyLinkInput" value="${selectEl.value}" />`;
          this.show_area[0].showcopysnackbar = true;
        } catch (err) {
          // this.copy_state = `複製失敗 ${err}`;
          this.show_area[0].showcopysnackbar = true;
        }
        // cancel select
        selectEl.setAttribute("type", "hidden");
        window.getSelection().removeAllRanges();
      }
    },
    BuyShop() {
      if (this.select_info[0].num_selection > 0) {
        // 詳細頁折價券星幣折抵需要再計算免運門檻
        this.select_info[0].shipping_free = this.select_info[0].shipping_free;
        this.select_info[0].old_shipping_fee = this.select_info[0].shipping_fee;
        // 計算是否符合免運門檻
        this.select_info[0].cal_price =
          this.select_info[0].num_selection * this.select_info[0].spec_price;
        if (
          this.select_info[0].cal_price >= this.select_info[0].shipping_free
        ) {
          this.select_info[0].shipping_fee = 0;
          this.select_info[0].total_price = this.select_info[0].cal_price;
        } else {
          this.select_info[0].total_price =
            this.select_info[0].cal_price + this.select_info[0].shipping_fee;
        }
        let user_field = [];
        user_field.push({
          num_selection: this.select_info[0].num_selection,
          num_selection_price: this.select_info[0].spec_price,
          num_selection_id: this.select_info[0].spec_id,
          num_selection_specname: parseInt(this.select_info[0].spec_name),
          num_selection_fee: this.select_info[0].shipping_fee,
          num_selection_shippingfree: this.select_info[0].shipping_free,
          num_selection_oldfee: this.select_info[0].old_shipping_fee,
          num_selection_coupon: 0,
          num_selection_calprice: this.select_info[0].cal_price,
          num_selection_totalprice: this.select_info[0].total_price,
          memo: this.select_info[0].memo,
          is_coupon_price: 0,
          is_star_price: 0,
          is_shopmoney_price: 0,
        });
        // store vuex
        this.$store.commit({
          type: "setShoplistData",
          shoplistData: user_field,
        });
        // console.log(this.$store.state.shoplist.shoplistData[0]);
        this.$router.push("/shopbuy");
      } else {
        alert("數量不可為0");
        return false;
      }
    },
    async GetGroupInfo() {
      if (
        this.$route.query.group_uuid !== "" &&
        this.$route.query.group_uuid !== undefined
      ) {
        self.group_uuid = this.$route.query.group_uuid;
        sessionStorage.setItem("group_uuid", this.group_uuid);
        sessionStorage.setItem("production_id", "");
      } else if (
        this.$route.query.production_id !== "" &&
        this.$route.query.production_id !== undefined
      ) {
        this.production_id = this.$route.query.production_id;
        sessionStorage.setItem("production_id", this.production_id);
        sessionStorage.setItem("group_uuid", "");
      } else {
        alert("取得商品失敗！！");
        return false;
      }
      await this.GetShopInfo();
      await this.checkLogin();
      this.page_finish = true;
    },
    checkUserAgent() {
      //  判斷是不是從app進入
      if (navigator.userAgent.indexOf("cheerlife") !== -1) {
        const geturl = window.location.search;
        if (geturl.indexOf("phone") >= 0) {
          this.mobile = this.$route.query.phone;
          // login axios
          Vue.axios({
            method: "post",
            url: `https://${process.env.VUE_APP_API}.cheerlife.io/cheerlife/v1/web-users/get-user-token`,
            data: {
              access_key: this.access_key,
              mobile: this.mobile,
            },
          })
            .then((response) => {
              // console.log(response);
              if (response.status === 200) {
                this.login_info[0].token = response.data.token;
                this.login_info[0].user_uuid = response.data.user_uuid;
                sessionStorage.setItem("accessToken", this.login_info[0].token);
                sessionStorage.setItem(
                  "user_uuid",
                  this.login_info[0].user_uuid
                );
                sessionStorage.setItem("mobile", this.mobile);
                // set cookies
                const expire_day = 1;
                const get_day = new Date();
                get_day.setTime(
                  get_day.getTime() + expire_day * 24 * 60 * 60 * 1000
                );
                const expires = `expires=${get_day.toGMTString()}`;
                document.cookie = `accessToken=${this.login_info[0].token}; expires=${expires};`;
                document.cookie = `user_uuid=${this.login_info[0].user_uuid}; expires=${expires};`;
                document.cookie = `mobile=${this.mobile}; expires=${expires};`;
                // has login
                this.not_login = false;
              } else {
                alert(response.data.message);
                return false;
              }
            })
            .catch((error) => {
              if (error.response.status === 401) {
                alert(error.response.data.message);
              } else {
                alert(`status code: ${error.response.status}`);
                alert(error.response.data.message);
              }
            });
          // has login
          this.not_login = false;
        } else {
          // alert('錯誤！！取不到手機號碼');
          // not login
          this.not_login = true;
        }
      } else {
        // not login
        this.not_login = true;
      }
    },
    checkUserState() {
      if (this.login_info[0].mobile !== "") {
        const mobile_re = /^[09]{2}[0-9]{8}$/;
        if (!mobile_re.test(this.login_info[0].mobile)) {
          alert("手機格式錯誤");
          return false;
        } else {
          Vue.axios({
            method: "post",
            url: `https://${process.env.VUE_APP_API}.cheerlife.io/cheerlife/v1/web-users/check-user-register`,
            data: {
              access_key: this.access_key,
              mobile: this.login_info[0].mobile,
            },
          })
            .then((response) => {
              // console.log(response);
              if (response.status === 200) {
                this.login_info[0].user_uuid = response.data.user_uuid;
                this.login_info[0].message = response.data.message;
                if (this.login_info[0].message !== "registered") {
                  this.SMSCountDownTimer();
                  this.login_info[0].el = 2;
                } else {
                  this.login_info[0].el = 4;
                }
              } else {
                alert(response.data.message);
                return false;
              }
            })
            .catch((error) => {
              alert(`status code: ${error.response.status}`);
              alert(error.response.data.message);
            });
        }
      } else {
        alert("未填寫手機");
        return false;
      }
    },
    SendSMSCode() {
      Vue.axios({
        method: "post",
        url: `https://${process.env.VUE_APP_API}.cheerlife.io/cheerlife/v1/web-users/send-verify`,
        data: {
          access_key: this.access_key,
          mobile: this.login_info[0].mobile,
          user_uuid: this.login_info[0].user_uuid,
        },
      })
        .then((response) => {
          if (response.status === 200) {
            alert("已發送！！");
            this.sms_btn[0].smsCountDown = 180;
            this.SMSCountDownTimer();
          } else {
            alert(response.data.message);
            return false;
          }
        })
        .catch((error) => {
          alert(`status code: ${error.response.status}`);
          alert(error.response.data.message);
        });
    },
    CheckSMSCode() {
      Vue.axios({
        method: "post",
        url: `https://${process.env.VUE_APP_API}.cheerlife.io/cheerlife/v1/web-users/check-verify-code`,
        data: {
          access_key: this.access_key,
          mobile: this.login_info[0].mobile,
          code: this.login_info[0].sns,
        },
      })
        .then((response) => {
          // console.log(response);
          if (response.status === 200) {
            this.login_info[0].token = response.data.token;
            this.login_info[0].el = 3;
          } else {
            alert(response.data.message);
            return false;
          }
        })
        .catch((error) => {
          alert(`status code: ${error.response.status}`);
          alert(error.response.data.message);
        });
    },
    SendPassword() {
      if (
        this.login_info[0].checknewpassword === this.login_info[0].newpassword
      ) {
        const password_re = /^.*(?=.{4,}).*$/;
        if (!password_re.test(this.login_info[0].newpassword)) {
          alert("密碼格式錯誤");
          return false;
        } else {
          Vue.axios({
            method: "post",
            url: `https://${process.env.VUE_APP_API}.cheerlife.io/cheerlife/v1/web-users/set-password`,
            headers: {
              Authorization: `Bearer ${this.login_info[0].token}`,
            },
            data: {
              user_uuid: this.login_info[0].user_uuid,
              password: this.Base64.encode(this.login_info[0].newpassword),
            },
          })
            .then((response) => {
              // console.log(response);
              if (response.status === 200) {
                alert("密碼設定成功！");
                sessionStorage.setItem("accessToken", this.login_info[0].token);
                sessionStorage.setItem(
                  "user_uuid",
                  this.login_info[0].user_uuid
                );
                sessionStorage.setItem("mobile", this.login_info[0].mobile);
                // set cookies
                const expire_day = 1;
                const get_day = new Date();
                get_day.setTime(
                  get_day.getTime() + expire_day * 24 * 60 * 60 * 1000
                );
                const expires = `expires=${get_day.toGMTString()}`;
                document.cookie = `accessToken=${this.login_info[0].token}; expires=${expires};`;
                document.cookie = `user_uuid=${this.login_info[0].user_uuid}; expires=${expires};`;
                document.cookie = `mobile=${this.login_info[0].mobile}; expires=${expires};`;
                // has login
                this.not_login = false;
              } else {
                alert(response.data.message);
                return false;
              }
            })
            .catch((error) => {
              alert(`status code: ${error.response.status}`);
              alert(error.response.data.message);
            });
        }
      } else {
        alert("密碼與確認密碼不相符！！");
        return false;
      }
    },
    forgetPassword() {
      this.set_password_tittle = this.$t("Home_title8");
      this.login_info[0].el = 2;
    },
    SendLogin() {
      let userpassword = this.Base64.encode(
        `${this.login_info[0].mobile}:${this.login_info[0].password}`
      );
      Vue.axios({
        method: "get",
        url: `https://${process.env.VUE_APP_API}.cheerlife.io/cheerlife/v1/web-users/login`,
        headers: {
          Authorization: `Basic ${userpassword}`,
        },
      })
        .then((response) => {
          // console.log(response);
          if (response.status === 200) {
            alert("成功！");
            this.login_info[0].token = response.data.token;
            // this.login_info[0].user_uuid = response.data.user_uuid;
            sessionStorage.setItem("accessToken", this.login_info[0].token);
            sessionStorage.setItem("user_uuid", this.login_info[0].user_uuid);
            sessionStorage.setItem("mobile", this.login_info[0].mobile);
            // set cookies
            const expire_day = 1;
            const get_day = new Date();
            get_day.setTime(
              get_day.getTime() + expire_day * 24 * 60 * 60 * 1000
            );
            const expires = `expires=${get_day.toGMTString()}`;
            document.cookie = `accessToken=${this.login_info[0].token}; expires=${expires};`;
            document.cookie = `user_uuid=${this.login_info[0].user_uuid}; expires=${expires};`;
            document.cookie = `mobile=${this.login_info[0].mobile}; expires=${expires};`;
            // has login
            this.not_login = false;
          } else {
            alert(response.data.message);
            return false;
          }
        })
        .catch((error) => {
          if (error.response.status === 401) {
            alert(error.response.data.message);
          } else {
            alert(`status code: ${error.response.status}`);
            alert(error.response.data.message);
          }
        });
    },
    GetShopInfo() {
      let product_field = [];
      let star_point = {
        user_star_point: 0,
        product_star_point: 0,
      };
      Vue.axios({
        method: "post",
        url: `https://${process.env.VUE_APP_API}.cheerlife.io/12team/v1/groups/direct_groupbuy_info`,
        data: {
          access_key: this.access_key,
          group_uuid: this.group_uuid,
          production_id: String(this.production_id),
        },
      })
        .then((response) => {
          // console.log(response);
          if (response.status === 200) {
            sessionStorage.setItem("group_uuid", response.data.group_uuid);
            sessionStorage.setItem("production_id", response.data.product_id);
            this.group_uuid = response.data.group_uuid;
            this.shop_info = response.data;
            for (let i = 0; i < this.shop_info.spec_list.length; i++) {
              if (this.shop_info.spec_list[i].spec_price === 0) {
                this.shop_info.spec_list.splice(
                  i,
                  this.shop_info.spec_list.length
                );
              }
            }
            this.select_info[0].spec_price = this.shop_info.spec_list[0].spec_price;
            this.select_info[0].spec_id = this.shop_info.spec_list[0].spec_id;
            this.select_info[0].shipping_free = this.shop_info.shipping_free;
            this.shop_info.comma_shipping_free = this.NumberWithCommas(
              this.shop_info.shipping_free
            );
            this.select_info[0].shipping_fee = this.shop_info.shipping_fee;
            // 智販機
            let set_pay_type = 1;
            this.is_vending_machine = this.shop_info.vending_machine;
            if (this.is_vending_machine === true) {
              set_pay_type = 4;
            } else {
              set_pay_type = 6;
            }
            // 信用卡
            this.shop_info.pay_type[0].pay_method = this.$t("credit_card");
            // Aftee 先享後付
            this.shop_info.pay_type[2].pay_method = this.$t("aftee");
            // 銀行轉帳
            this.shop_info.pay_type[4].pay_method = this.$t("atm");
            product_field.push({
              product_name: this.shop_info.name,
              product_spec: this.shop_info.spec,
              product_img: this.shop_info.image_url,
              product_id: this.shop_info.product_id,
              product_pay_type: this.shop_info.pay_type,
              product_pay_type_choose: set_pay_type,
              coupon: "",
              starpoint: 0,
              shopmoney: 0,
              // 使用折扣種類 discount_type
              usecostprice: 0,
              vending_machine: this.shop_info.vending_machine,
            });
            // store vuex
            this.$store.commit({
              type: "setProductinfoData",
              productinfoData: product_field,
            });
            star_point.product_star_point = this.shop_info.cheer_point;
            // store vuex
            this.$store.commit({
              type: "setStarPointData",
              starpointData: star_point,
            });
          } else {
            alert(response.data.message);
            return false;
          }
        })
        .catch((error) => {
          alert(`status code: ${error.response.status}`);
          alert(error.response.data.message);
        });
    },
    // get cookie
    readCookie(name) {
      var nameEQ = name + "=";
      var ca = document.cookie.split(";");
      for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == " ") c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
      }
      return null;
    },
    checkLogin() {
      if (
        this.readCookie("accessToken") !== "" &&
        this.readCookie("accessToken") !== null &&
        this.readCookie("user_uuid") !== "" &&
        this.readCookie("user_uuid") !== null
      ) {
        sessionStorage.setItem("accessToken", this.readCookie("accessToken"));
        sessionStorage.setItem("user_uuid", this.readCookie("user_uuid"));
        this.login_info[0].user_uuid = this.readCookie("user_uuid");
        Vue.axios({
          method: "post",
          url: `https://${process.env.VUE_APP_API}.cheerlife.io/cheerlife/v1/web-users/user-info`,
          headers: {
            Authorization: `Bearer ${this.readCookie("accessToken")}`,
          },
          data: {
            user_uuid: this.readCookie("user_uuid"),
          },
        })
          .then((response) => {
            // console.log(response);
            if (response.status === 200) {
              this.not_login = false;
            } else {
              alert(response.data.message);
              this.not_login = true;
            }
          })
          .catch((error) => {
            alert(`status code: ${error.response.status}`);
            alert(error.response.data.message);
            if (error.response.data.message === "token過期") {
              sessionStorage.setItem("accessToken", "");
              sessionStorage.setItem("user_uuid", "");
              document.cookie =
                "accessToken" +
                "=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;";
              document.cookie =
                "user_uuid" +
                "=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;";
            }
            this.not_login = true;
          });
      } else {
        if (
          sessionStorage.getItem("accessToken") !== "" &&
          sessionStorage.getItem("accessToken") !== null &&
          sessionStorage.getItem("user_uuid") !== "" &&
          sessionStorage.getItem("user_uuid") !== null
        ) {
          this.login_info[0].user_uuid = sessionStorage.getItem("user_uuid");
          Vue.axios({
            method: "post",
            url: `https://${process.env.VUE_APP_API}.cheerlife.io/cheerlife/v1/web-users/user-info`,
            headers: {
              Authorization: `Bearer ${sessionStorage.getItem("accessToken")}`,
            },
            data: {
              user_uuid: sessionStorage.getItem("user_uuid"),
            },
          })
            .then((response) => {
              // console.log(response);
              if (response.status === 200) {
                this.not_login = false;
              } else {
                alert(response.data.message);
                this.not_login = true;
              }
            })
            .catch((error) => {
              alert(`status code: ${error.response.status}`);
              alert(error.response.data.message);
              if (error.response.data.message === "token過期") {
                sessionStorage.setItem("accessToken", "");
                sessionStorage.setItem("user_uuid", "");
                document.cookie =
                  "accessToken" +
                  "=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;";
                document.cookie =
                  "user_uuid" +
                  "=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;";
              }
              this.not_login = true;
            });
        } else {
          this.not_login = true;
        }
      }
    },
    dialogCancel() {
      this.login_info[0].el = 1;
      this.login_dialog = false;
    },
    selectSpecs() {
      this.spec_sheet = !this.spec_sheet;
    },
    minusClick() {
      if (this.select_info[0].num_selection > 0) {
        this.select_info[0].num_selection--;
      } else {
        this.select_info[0].num_selection = 0;
      }
    },
    plusClick() {
      if (this.select_info[0].num_selection <= this.shop_info.mum_limit) {
        this.select_info[0].num_selection++;
      } else {
        return false;
      }
    },
    changeSpec(num) {
      this.select_info[0].spec_name = this.shop_info.spec_list[num].spec_name;
      this.select_info[0].spec_price = this.shop_info.spec_list[num].spec_price;
      this.select_info[0].spec_id = this.shop_info.spec_list[num].spec_id;
    },
    SMSCountDownTimer() {
      if (this.sms_btn[0].smsCountDown > 0) {
        this.sms_btn[0].smsbtndisable = true;
        setTimeout(() => {
          this.sms_btn[0].smsCountDown -= 1;
          this.SMSCountDownTimer();
        }, 1000);
      } else {
        this.sms_btn[0].smsbtndisable = false;
      }
    },
    NumberWithCommas(num) {
      return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
  },
  created() {},
  mounted() {
    this.GetGroupInfo();
    this.checkUserAgent();
    this.initShareURL();
  },
  watch: {},
};
</script>
<style>
.home input.showcopyLinkInput {
  border-style: dashed !important;
  width: 100%;
}
.v-card__title {
  word-break: break-word !important;
  word-wrap: break-word !important;
  line-height: 130%;
}
.v-card__title:last-of-type {
  font-size: 15px;
  padding-left: 0;
  line-height: 150%;
}
</style>
<style scoped>
.v-item-group.v-bottom-navigation .v-btn.v-size--default {
  height: inherit;
}
.shopinfo_sty >>> img {
  max-width: 100% !important;
  width: auto !important;
  height: auto !important;
  margin-left: 0 !important;
  margin-right: 0 !important;
  display: block;
}
</style>
